import React from 'react';
import { Container } from './styles';
import { AlertIcon } from './AlertIcon';

export const Error404: React.FC = () => {
  return (
    <Container>
      <div className="content_wrapper">
        <div className='left'>
          <AlertIcon />
        </div>
        <div className='right'>
          <h1>404</h1>
            <p>Algo aconteceu ao carregar a página!</p>
            <p>tente recarregar a página ou aguarde alguns minutos.</p>
            <strong>Desculpe o transtorno!</strong>
        </div>
      </div>
    </Container>
  );
};